import { Flex, Button } from "@mantine/core";
import { Plus, ChevronsUpDown, Minus } from "lucide-react";

interface ZoomControlsProps {
    setScale: React.Dispatch<React.SetStateAction<number>>;
}

const ZoomControls: React.FC<ZoomControlsProps> = ({ setScale }) => {
    const handleZoomIn = () => setScale(prevScale => Math.min(prevScale + 0.1, 2));
    const handleZoomOut = () => setScale(prevScale => Math.max(prevScale - 0.1, 0.5));
    const handleResetScale = () => setScale(1);

    return (
        <Flex
            style={{
                position: 'absolute',
                bottom: 20,
                right: 10
            }}
        >
            <Button
                size='compact-xs'
                onClick={handleZoomIn}
                style={{
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0
                }}
                color={'dark'}
            >
                <Plus size={20} />
            </Button>

            <Button
                size='compact-xs'
                radius={0}
                onClick={handleResetScale}
                color={'dark'}
            >
                <ChevronsUpDown size={20} />
            </Button>

            <Button
                size='compact-xs'
                onClick={handleZoomOut}
                style={{
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0
                }}
                color={'#141517'}
            >
                <Minus size={20} />
            </Button>
        </Flex>
    );
};

export default ZoomControls;
